import "./src/styles/global.css";
// import getFirebaseApp from "./src/firebaseApp";

export const onClientEntry = () => {
  // Inicializa o Firebase quando o cliente carrega
  // getFirebaseApp();

  // Defensive cleanup: if a legacy SW is still registered on the root scope,
  // unregister it and clear caches. This complements `static/sw.js` (which
  // auto-unregisters), and helps users who can already load the page.
  if (typeof window === "undefined") return;
  if (!("serviceWorker" in navigator)) return;

  navigator.serviceWorker
    .getRegistrations()
    .then(async (regs) => {
      const origin = window.location.origin;
      const rootScope = `${origin}/`;

      const targets = regs.filter((reg) => {
        // Only touch the legacy root SW, do not affect other scopes (e.g. Partytown).
        if (reg.scope !== rootScope) return false;
        try {
          const activeUrl = reg.active?.scriptURL
            ? new URL(reg.active.scriptURL).pathname
            : "";
          const installingUrl = reg.installing?.scriptURL
            ? new URL(reg.installing.scriptURL).pathname
            : "";
          const waitingUrl = reg.waiting?.scriptURL
            ? new URL(reg.waiting.scriptURL).pathname
            : "";
          return [activeUrl, installingUrl, waitingUrl].some(
            (p) => p === "/sw.js"
          );
        } catch {
          return false;
        }
      });

      if (!targets.length) return;

      await Promise.all(
        targets.map(async (reg) => {
          try {
            await reg.unregister();
          } catch {
            // ignore
          }
        })
      );

      try {
        const keys = await caches.keys();
        await Promise.all(keys.map((k) => caches.delete(k)));
      } catch {
        // ignore
      }
    })
    .catch(() => {});

  // If our temporary cleanup SW couldn't navigate the page, this ensures we still reload.
  navigator.serviceWorker.addEventListener("message", (event) => {
    if (event?.data?.type === "SW_CLEANUP") {
      window.location.reload();
    }
  });
};
